import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import withSideEffect from 'react-side-effect';
import isEqual from 'react-fast-compare';

import {
  setShowHeader,
  setShowFooter,
  setSlogan,
  setBacklink,
  setCurrentTitle,
  setMenu,
  setMenuShow,
  setMenuValue,
} from 'cityads-v3/actions/header';

import {
  showFab as setShowFab,
} from 'cityads-v3/actions/fab';

import { setVisible } from 'cityads-v3/actions/menu'

const Balaclava = InnerComponent =>
  class BalaclavaWrapper extends Component {
    static propTypes = {
      showHeader: PropTypes.bool,
      showFooter: PropTypes.bool,
      showLeftMenu: PropTypes.bool,

      slogan: PropTypes.string,

      backlink    : PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.shape({
          pathname: PropTypes.string,
          search  : PropTypes.string,
          hash    : PropTypes.string,
          state   : PropTypes.object,
        })
      ]),
      backlinkText: PropTypes.string,

      title: PropTypes.string,

      menuShow : PropTypes.bool,
      menuValue: PropTypes.any,
      menu     : PropTypes.arrayOf(PropTypes.shape({
        id   : PropTypes.any.isRequired,
        title: PropTypes.string.isRequired,
        route: PropTypes.string.isRequired,
        total: PropTypes.number,
      })),

      showFab: PropTypes.bool,

      defauls: PropTypes.shape({
        showHeader  : PropTypes.bool,
        showFooter: PropTypes.bool,
        showLeftMenu: PropTypes.bool,
        slogan      : PropTypes.string,
        backlink    : PropTypes.string,
        backlinkText: PropTypes.string,
        title       : PropTypes.string,
        menuShow    : PropTypes.bool,
        menuValue   : PropTypes.any,
        menu        : PropTypes.arrayOf(PropTypes.shape({
          id   : PropTypes.any.isRequired,
          title: PropTypes.string.isRequired,
          route: PropTypes.string.isRequired,
          total: PropTypes.number,
        })),
        showFab     : PropTypes.bool,
      })
    };

    static peek = InnerComponent.peek;

    static flushToStore = (dispatch) => {
      let state = InnerComponent.rewind();

      return flushToStore(dispatch, state);
    }

    static set canUseDOM(canUseDOM) {
      InnerComponent.canUseDOM = canUseDOM;
    }

    shouldComponentUpdate(nextProps) {
      return !isEqual(this.props, nextProps);
    }

    render() {
      return <InnerComponent {...this.props} />
    }
  }
;


function reducePropsToState(propsList) {
  return propsList.reduce(
    (allProps, curProps) => ({
      ...allProps,
      ...curProps,
    }),
    {}
  );
}

function handleStateChangeOnClient({ dispatch, ...state }) {
  flushToStore(dispatch, state);
}

function flushToStore(dispatch, state) {
  if (!dispatch) {
    console.warn('No mounted instances, unable to dispatch');
    return;
  }

  const {
    showHeader,
    showFooter,
    showLeftMenu = true,
    slogan,
    backlink,
    backlinkText,
    title,
    menu,
    menuValue,
    menuShow,
    showFab,
    defaults,
  } = state;

  dispatch(setShowHeader(showHeader))
  dispatch(setShowFooter(showFooter))
  dispatch(setVisible(showLeftMenu))
  dispatch(setSlogan(slogan))
  dispatch(setBacklink(backlink, backlinkText))
  dispatch(setCurrentTitle(title))
  dispatch(setMenu(menu))
  dispatch(setMenuValue(menuValue))
  dispatch(setMenuShow(menuShow))
  dispatch(setShowFab(showFab))

  const balaclava = {
    showHeader,
    showFooter,
    showLeftMenu,
    slogan,
    backlink,
    backlinkText,
    title,
    menu,
    menuValue,
    menuShow,
    showFab,
  };

  return !isEqual(balaclava, defaults)
}

const NullComponent = () => null;

const BalaclavaSideEffects = withSideEffect(
  reducePropsToState,
  handleStateChangeOnClient,
)(NullComponent);

const BalaclavaWrapped = Balaclava(BalaclavaSideEffects);
const BalaclavaConnected = connect()(BalaclavaWrapped);

BalaclavaConnected.peek = BalaclavaWrapped.peek;
BalaclavaConnected.flushToStore = BalaclavaWrapped.flushToStore;

export default BalaclavaConnected;
